import { render, staticRenderFns } from "./UploadEvidenceBtn.vue?vue&type=template&id=63d912d8&scoped=true"
import script from "./UploadEvidenceBtn.vue?vue&type=script&lang=js"
export * from "./UploadEvidenceBtn.vue?vue&type=script&lang=js"
import style0 from "./UploadEvidenceBtn.vue?vue&type=style&index=0&id=63d912d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d912d8",
  null
  
)

export default component.exports